import { Skeleton } from 'antd';
import styled from 'styled-components';

export const OHLCContainer = styled.div`
  overflow: auto;
`;

export const OHLCTable = styled.table`
  align-self: center;
  background: #ffffff;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  table-layout: fixed;
  width: 321px;

  tbody {
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 320px;
  }

  thead, tbody tr, tfoot {
    display: table;
    width: 320px;
    table-layout: fixed;
  }

  tbody, tfoot {
    .blurred {
      opacity: 0.4;
    }
  }

  tbody > tr.best-bid-offer {
    border-width: 5px 3px;
    border-style: solid; 
    border-color: #EDEDED;

    td > p {
      line-height: 14px;
      font-weight: normal;
      text-align: center;
      padding: 4px 0px;
    }
  }

  thead {
    th:first-child, th:last-child {
      width: 40px;
    }

    th:nth-child(2), th:nth-child(5) {
      width: 66.5px;
    }

    th:nth-child(3), th:nth-child(4) {
      width: 50px;
    }
  }

  tbody {
    td:first-child, td:last-child {
      width: 40px;
    }

    td:nth-child(2), td:nth-child(5) {
      width: 66.5px;
    }

    td:nth-child(3), td:nth-child(4) {
      width: 50px;
    }
  }

  tfoot {
    td:nth-child(3) {
      width: 100px;
    }

    td:first-child, td:last-child {
      width: 40px;
    }

    td:nth-child(2), td:nth-child(4) {
      width: 66.5px;
    }
  }
`;

export const OHLCTableHead = styled.thead`
  border-bottom: 1px solid #dadada;
`;

export const OHLCTableHeadData = styled.th`
  background: #f7f7f7;
  padding: 8px 0;
  color: #333333;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
`;

export const OHLCTableBodyData = styled.td`
  padding: 0;
`;

export const OHLCCellText = styled.p<{
  color?: string;
  minWidth?: number;
  maxWidth?: number;
}>`
  color: ${({ color }) => color || '#333333'};
  min-width: ${({ minWidth }) => (minWidth ? `${minWidth}px` : 'unset')};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'unset')};
  margin: 0;
  padding: 8px 0;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;

  &:empty::before {
    content: '';
    display: inline-block;
  }
`;

export const OHLCTableFoot = styled.tfoot`
  border-top: 1px solid #dadada;
  background: #f7f7f7;
`;

export const OHLCTableFootData = styled.td`
  color: #333333;
  margin: 0;
  padding: 8px 0;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`;

export const TableOHLCTextSkeleton = styled(Skeleton.Button)`
  display: flex;
  justify-content: center;

  & > .ant-skeleton-button {
    vertical-align: middle;
    width: 80%;
    height: 16px;
  }
`;
